import { Descendant, Node } from 'slate';

export default (nodes: Descendant[]) => {
    return nodes.map(n => Node.string(n)).join('\n');
}
